'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { FormattedMessage } from 'LearningCenterUI/components/I18n';
import ProfessorCard from './ProfessorCard';
import useMediaQuery from '../../../hooks/useMediaQuery';
import { device } from '../../../constants/StyledComponentConstants';
import Carousel from '../../Carousel';
import ModalTile, { ModalTileSection } from './ModalTile';
import SectionHeading from '../../SectionHeading';
import FullWidthBackgroundColor from './FullWidthBackgroundColor';
const BackgroundTile = styled(ModalTile).withConfig({
  displayName: "OverviewModalProfessorsSection__BackgroundTile",
  componentId: "r79nok-0"
})(["background-color:transparent;margin-top:0 !important;position:relative;"]);

const PlainWrapper = ({
  children
}) => /*#__PURE__*/_jsx("div", {
  children: children
});

const OverviewModalProfessorsSection = ({
  professors,
  language
}) => {
  const isMobile = useMediaQuery(`screen and ${device.mobile}`);
  const ProfessorCardsLayout = isMobile || professors.length < 2 ? PlainWrapper : Carousel;
  return /*#__PURE__*/_jsxs(BackgroundTile, {
    children: [/*#__PURE__*/_jsx(FullWidthBackgroundColor, {
      $color: "GYPSUM"
    }), /*#__PURE__*/_jsxs(ModalTileSection, {
      children: [/*#__PURE__*/_jsx(SectionHeading, {
        className: "p-bottom-4",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.overviewModal.professors"
        })
      }), /*#__PURE__*/_jsx(ProfessorCardsLayout, {
        fixedMargin: true,
        pageMargin: isMobile ? 12 : 32,
        children: professors.map(professor => /*#__PURE__*/_jsx(ProfessorCard, {
          description: professor.descriptions[language.toLowerCase()],
          imageUrl: professor.image,
          name: professor.name,
          widthRatio: professors.length > 1 ? 0.8 : 1
        }, professor.id))
      })]
    })]
  });
};

export default OverviewModalProfessorsSection;